/*
 * return-form.js — Return request form.
 *
 * Submits multipart/form-data straight to FormBold. There is no server hop:
 * Shopify cannot proxy it and Catalyst never did either. Keep the field names
 * (`name`, `email`, `phone`, `message`) in sync with the FormBold form
 * definition — Catalyst's split `firstname` / `lastname` is now one field.
 */

(function () {
  var ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
  var TEXT_FIELDS = ['name', 'email', 'phone', 'message'];

  // FormBold stores any file part, whatever the field is called, but rejects
  // the whole submission with a 400 when two parts share a name — `upload`
  // twice and `upload[]` twice both fail. Hence the index suffix.
  // `upload` is the name in FormBold's own docs, so a lone file keeps it bare.
  var FILE_FIELD = 'upload';

  function fileFieldName(index, total) {
    return total === 1 ? FILE_FIELD : FILE_FIELD + '[' + index + ']';
  }

  function initReturnForm(root) {
    var form = root.querySelector('[data-return-form-fields]');
    var fileInput = root.querySelector('[data-file-input]');
    var fileList = root.querySelector('[data-file-list]');
    var fileCount = root.querySelector('[data-file-count]');
    var fileError = root.querySelector('[data-file-error]');
    var attachTrigger = root.querySelector('[data-attach-trigger]');
    var submit = root.querySelector('[data-submit]');
    var success = root.querySelector('[data-status-success]');
    var error = root.querySelector('[data-status-error]');

    if (!form || !fileInput) return;

    var endpoint = root.dataset.endpoint;
    var maxFiles = parseInt(root.dataset.maxFiles, 10) || 3;
    var maxFileSize = parseInt(root.dataset.maxFileSize, 10) || 1024 * 1024;
    var files = [];

    function setFileError(message) {
      fileError.textContent = message || '';
      fileError.hidden = !message;
    }

    function validateFile(file) {
      if (ALLOWED_TYPES.indexOf(file.type) === -1) return root.dataset.errorFileType;
      if (file.size > maxFileSize) return root.dataset.errorFileSize;
      return null;
    }

    function renderFiles() {
      fileList.textContent = '';

      files.forEach(function (file, index) {
        var item = document.createElement('li');
        item.className = 'return-form__file-item';

        var name = document.createElement('span');
        name.className = 'return-form__file-name';
        name.textContent = file.name;

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'return-form__file-remove';
        remove.setAttribute('aria-label', root.dataset.labelRemove);
        remove.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 18 18" fill="currentColor" aria-hidden="true">' +
          '<path d="M9 7.94l3.71-3.71 1.06 1.06-3.71 3.71 3.71 3.71-1.06 1.06-3.71-3.71-3.71 3.71-1.06-1.06 3.71-3.71-3.71-3.71L5.29 4.23 9 7.94z"/>' +
          '</svg>';
        remove.addEventListener('click', function () {
          files.splice(index, 1);
          setFileError('');
          renderFiles();
        });

        item.appendChild(name);
        item.appendChild(remove);
        fileList.appendChild(item);
      });

      fileList.hidden = files.length === 0;
      fileCount.textContent = String(files.length);
      attachTrigger.disabled = files.length >= maxFiles;
      fileInput.disabled = files.length >= maxFiles;
    }

    function showStatus(panel) {
      form.hidden = true;
      panel.hidden = false;
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function reset() {
      form.reset();
      files = [];
      setFileError('');
      renderFiles();
      success.hidden = true;
      error.hidden = true;
      form.hidden = false;
    }

    attachTrigger.addEventListener('click', function () {
      fileInput.click();
    });

    fileInput.addEventListener('change', function () {
      var selected = Array.prototype.slice.call(fileInput.files);

      // Clearing the input lets the same file be picked again after removal.
      fileInput.value = '';
      setFileError('');

      if (!selected.length) return;

      if (files.length + selected.length > maxFiles) {
        setFileError(root.dataset.errorMaxFiles);
        return;
      }

      for (var i = 0; i < selected.length; i += 1) {
        var message = validateFile(selected[i]);

        if (message) {
          setFileError(message);
          return;
        }
      }

      files = files.concat(selected);
      renderFiles();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var payload = new FormData();

      TEXT_FIELDS.forEach(function (name) {
        var field = form.elements[name];

        if (field && field.value) payload.append(name, field.value);
      });

      files.forEach(function (file, index) {
        payload.append(fileFieldName(index, files.length), file);
      });

      submit.disabled = true;
      submit.textContent = root.dataset.labelSending;

      fetch(endpoint, { method: 'POST', body: payload })
        .then(function (response) {
          showStatus(response.ok ? success : error);
        })
        .catch(function () {
          showStatus(error);
        })
        .then(function () {
          submit.disabled = false;
          submit.textContent = root.dataset.labelSubmit;
        });
    });

    root.querySelectorAll('[data-reset]').forEach(function (button) {
      button.addEventListener('click', reset);
    });

    renderFiles();
  }

  document.querySelectorAll('[data-return-form]').forEach(initReturnForm);
})();
